// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-impact-navigation-bar[data-v-aeb975f4]{position:fixed;z-index:15;width:1128px;bottom:var(--footer-height);background:#fff;height:56px;display:flex;justify-content:space-between;align-items:center;border-top:1px solid var(--v-gray-pale);padding:0 1rem}.app-impact-navigation-bar .add-to-library-btn[data-v-aeb975f4]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
